import {Collection} from "mobx-graphlink";
import {AccessPolicy} from "./DB/accessPolicies/@AccessPolicy.js";
import {Activity} from "./DB/activities/@Activity.js";
import {Bundle} from "./DB/bundles/@Bundle.js";
import {EchoCorpusBullet} from "./DB/echoCorpusBullets/@EchoCorpusBullet.js";
import {EchoProfile} from "./DB/echoProfiles/@EchoProfile.js";
import {EchoRound} from "./DB/echoRounds/@EchoRound.js";
import {EchoStory} from "./DB/echoStories/@EchoStory.js";
import {EngineConfig} from "./DB/engineConfigs/@EngineConfig.js";
import {Entity} from "./DB/entities/@Entity.js";
import {GlobalData} from "./DB/globalData/@GlobalData.js";
import {JournalEntry} from "./DB/journalEntries/@JournalEntry.js";
import {Light} from "./DB/lights/@Light.js";
import {RecordingSession} from "./DB/recordingSessions/@RecordingSession.js";
import {Scene} from "./DB/scenes/@Scene.js";
import {Script} from "./DB/scripts/@Script.js";
import {Session} from "./DB/sessions/@Session.js";
import {Shake} from "./DB/shakes/@Shake.js";
import {Sound} from "./DB/sounds/@Sound.js";
import {StatView} from "./DB/statViews/@StatView.js";
import {Story} from "./DB/stories.js";
import {StoryMessage} from "./DB/storyMessages/@StoryMessage.js";
import {TestSegment} from "./DB/testSegments/@TestSegment.js";
import {TimelineEvent} from "./DB/timelineEvents/@TimelineEvent.js";
import {UserHidden} from "./DB/userHiddens/@UserHidden.js";
import {User} from "./DB/users/@User.js";
import {MapObject} from "./DB/mapObjects/@MapObject.js";
import {DMap} from "./DB/maps/@Map.js";

declare module "mobx-graphlink/Dist/UserTypes" {
	interface UT_DBShape extends GraphDBShape {}
}

// helper, to avoid need to ensure each type is runtime-imported as well (needed for their schemas to be registered)
function DefineCollection<T>(typeConstructor: new(..._)=>T): Collection<T> {
	return undefined as any;
}

export class GraphDBShape {
	//general: Collection_Closed<{data: GeneralData}>;
	globalData = DefineCollection(GlobalData);

	// from modules
	/*modules: Collection_Closed<{
		// feedback: FeedbackDBShape;
	}>;*/
	/*feedback_proposals = DefineCollection(Proposal);
	feedback_userInfos = DefineCollection(Feedback_UserInfo);*/

	accessPolicies = DefineCollection(AccessPolicy);
	activities = DefineCollection(Activity);
	bundles = DefineCollection(Bundle);
	echoCorpusBullets = DefineCollection(EchoCorpusBullet);
	echoProfiles = DefineCollection(EchoProfile);
	echoRounds = DefineCollection(EchoRound);
	echoStories = DefineCollection(EchoStory);
	entities = DefineCollection(Entity);
	engineConfigs = DefineCollection(EngineConfig);
	journalEntries = DefineCollection(JournalEntry);
	lights = DefineCollection(Light);
	maps = DefineCollection(DMap);
	mapObjects = DefineCollection(MapObject);
	recordingSessions = DefineCollection(RecordingSession);
	scenes = DefineCollection(Scene);
	scripts = DefineCollection(Script);
	sessions = DefineCollection(Session);
	shakes = DefineCollection(Shake);
	sounds = DefineCollection(Sound);
	statViews = DefineCollection(StatView);
	stories = DefineCollection(Story);
	storyMessages = DefineCollection(StoryMessage);
	testSegments = DefineCollection(TestSegment);
	timelineEvents = DefineCollection(TimelineEvent);
	users = DefineCollection(User);
	userHiddens = DefineCollection(UserHidden);
	//userProcessMessages = DefineCollection(ProcessMessage); // don't use db for this; process-messages care about latency, so should be handled by app-server directly
}
export type DBCollection = keyof GraphDBShape;

// db constants
// note: keep in-sync with rust-shared/src/utils/db_constants.rs
// ==========

export const systemUserID =		"LF_SYSTEM_000000000001";
export const systemUserName =		"[system]";
export const systemUserEmail =	"debatemap@gmail.com";

export const systemPolicy_publicUngoverned_name = "Public, ungoverned (standard)";
export const systemPolicy_publicGoverned_name = "Public, governed (standard)";
export const systemPolicy_privateGoverned_name = "Private, governed (standard)";

/*export const globalMapID =			"GLOBAL_MAP_00000000001";
export const globalRootNodeID =	"GLOBAL_ROOT_0000000001";*/